const MATERIAL_DATA = {
  sand: { id: 'sand', label: 'Sand', shortLabel: 'sd', color: 0xd8c48b, sellPrice: 4 },
  iron: { id: 'iron', label: 'Iron', shortLabel: 'Fe', color: 0x8b7d77, sellPrice: 4 },
  carbon: { id: 'carbon', label: 'Carbon', shortLabel: 'C', color: 0x9ca3af, sellPrice: 4 },
  copper: { id: 'copper', label: 'Copper', shortLabel: 'Cu', color: 0xd97757, sellPrice: 5 },
  slag: { id: 'slag', label: 'Slag', shortLabel: 'sl', color: 0x57534e, sellPrice: -2 },
  glass: { id: 'glass', label: 'Glass', shortLabel: 'gl', color: 0xa5f3fc, sellPrice: 10 },
  silicon: { id: 'silicon', label: 'Silicon', shortLabel: 'Si', color: 0x64748b, sellPrice: 11 },
  steel: { id: 'steel', label: 'Steel', shortLabel: 'st', color: 0x94a3b8, sellPrice: 22 },
  motor: { id: 'motor', label: 'Motor', shortLabel: 'mt', color: 0xf59e0b, sellPrice: 37 },
  solarPanel: {
    id: 'solarPanel',
    label: 'Solar Panel',
    shortLabel: 'sp',
    color: 0x1d4ed8,
    sellPrice: 44,
  },
  rover: { id: 'rover', label: 'Rover', shortLabel: 'rv', color: 0xf43f5e, sellPrice: 115 },
} as const;

export type MaterialId = keyof typeof MATERIAL_DATA;

export interface MaterialDef {
  id: MaterialId;
  label: string;
  shortLabel: string;
  color: number;
  sellPrice: number;
}

export const MATERIALS: Record<MaterialId, MaterialDef> = MATERIAL_DATA;

export function countMaterials(sequence: MaterialId[]): Map<MaterialId, number> {
  const counts = new Map<MaterialId, number>();
  for (const material of sequence) counts.set(material, (counts.get(material) ?? 0) + 1);
  return counts;
}

export function materialColorHex(id: MaterialId): string {
  return `#${MATERIALS[id].color.toString(16).padStart(6, '0')}`;
}
